import AjaxCommons from '@/services/ajax-commons';

class SessionServiceImpl {

  public get = () => {
    return window.localStorage.getItem('session');
  }

  public set = (session: string) => {
    window.localStorage.setItem('session', session);
  }

  public logout = () => {
    window.localStorage.setItem('session', '');
  }
}

const SessionService = new SessionServiceImpl();

export default SessionService;
export { SessionServiceImpl };
